var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-img"},[_c('span',{staticClass:"coupon-img-title"},[_vm._v("￥ "+_vm._s(_vm.faceValue))]),(_vm.couponType === '01')?_c('span',[_vm._v("满"+_vm._s(_vm.overNYuanUse)+"元可用")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }